
<div *ngIf="profileInformation && profileInformation.length">
    <div *ngFor="let profile of profileInformation">
        <div *ngIf="profile.network === 'linkedin' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/linkedin.svg" alt="linkedIn">
            <span class="text-style">LinkedIn</span>
        </div>
        <hr *ngIf="profile.network === 'facebook' " class="source-hr-border">
        <div *ngIf="profile.network === 'facebook' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/Facebook.svg" alt="facebook">
            <span class="text-style">Facebook</span>
        </div>
        <hr *ngIf="profile.network === 'twitter' " class="source-hr-border">
        <div *ngIf="profile.network === 'twitter' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/X.svg" alt="twitter">
            <span class="text-style">Twitter</span>
        </div>
        <hr *ngIf="profile.network === 'github' " class="source-hr-border">
        <div *ngIf="profile.network === 'github' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/Githib.svg" alt="github">
            <span class="text-style">GitHub</span>
        </div>
        <hr *ngIf="profile.network === 'stackoverflow' " class="source-hr-border">
        <div *ngIf="profile.network === 'stackoverflow' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/stack_overflow.svg" alt="stackoverflow">
            <span class="text-style">Stack Overflow</span>
        </div>
        <hr *ngIf="profile.network === 'dribbble' " class="source-hr-border">
        <div *ngIf="profile.network === 'dribbble' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/dribbble.svg" alt="dribbble">
            <span class="text-style">Dribbble</span>
        </div>
        <hr *ngIf="profile.network === 'behance' " class="source-hr-border">
        <div *ngIf="profile.network === 'behance' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/behance.svg" alt="behance">
            <span class="text-style">Behance</span>
        </div>
        <hr *ngIf="profile.network === 'angellist' " class="source-hr-border">
        <div *ngIf="profile.network === 'angellist' " class="profile-main-div">
            <img class="source-icon-style" src="../../assets/svg/angellist.svg" alt="angellist">
            <span class="text-style">AngelList</span>
        </div>
    </div>
</div>
